import types from './notifyTypes';

const initialState = {
  isVisible: false,
  type: '',
  content: '',
};

const notifyReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.SET_NOTIFY_STATUS:
      return payload;
    default:
      return state;
  }
};

export default notifyReducer;
